import React, { useEffect } from "react";
import Heading from "../../components/Heading";
import CustomDivider from "../../components/CustomDivider";
import PolicyHolderSummary from "../summary/PolicyHolderSummary";
import VehicleDetailsSummary from "../summary/VehicleDetailsSummary";
import ResidentialAddressSummary from "../summary/ResidentialAddressSummary";
import NightParkingSummary from "../summary/NightParkingSummary";
import DayParkingSummary from "../summary/DayParkingSummary";
import RegularDriverSummary from "../summary/RegularDriverSummary";
import LicenseSummary from "../summary/LicenseSummary";

const Summary = ({ onEdit }: { onEdit: (page: number) => void }) => {
  const summaryItems = [
    {
      title: "Policy holder details",
      component: <PolicyHolderSummary onEdit={() => onEdit(1)} />,
    },
    {
      title: "Vehicle details",
      component: <VehicleDetailsSummary onEdit={() => onEdit(2)} />,
    },
    {
      title: "Residential Address",
      component: <ResidentialAddressSummary onEdit={() => onEdit(3)} />,
    },
    {
      title: "Night parking",
      component: <NightParkingSummary onEdit={() => onEdit(4)} />,
    },
    {
      title: "Day parking",
      component: <DayParkingSummary onEdit={() => onEdit(5)} />,
    },
    {
      title: "Regular driver",
      component: <RegularDriverSummary onEdit={() => onEdit(6)} />,
    },
    {
      title: "License",
      component: <LicenseSummary onEdit={() => onEdit(7)} />,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Heading>Summary</Heading>
      <div className="join join-vertical w-full mt-4">
        {summaryItems.map((item) => (
          <>
            <div className="collapse collapse-arrow">
              <input type="checkbox" />
              <div className="collapse-title text-lg font-medium">
                {item.title}
              </div>
              <div className="collapse-content">{item.component}</div>
            </div>
            <CustomDivider />
          </>
        ))}
      </div>
    </>
  );
};

export default Summary;
